import { SYSTEM_ERROR } from "../config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllCities = () => {
  return new Promise((resolve, reject) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json", Authorization: null },
      };
      axios
        .get(
          `${BaseUrl}/sanctum/csrf-cookie`,
          config
        )
        .then((response) => {
          axios
            .get(
              `${BaseUrl}/api/country/id/cities`,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              axios.defaults.headers.common["X-CSRF-TOKEN"] = response;

              resolve(res.data);
            })

            .catch((err) => {
              reject("Error in getAllTrips axios!");
            });
        });
    } catch (error) {
      console.error("in tripServices > getAllTrips, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
